<template>
  <y-shelf title="安全中心">
    <span slot="right"></span>
    <div slot="content">
      <div class="deposit-main">

      </div>
    </div>
  </y-shelf>
</template>

<script>
  import YShelf from '/components/YShelf'
  export default {
    components: {
      YShelf
    }
  }
</script>

<style lang="scss" scoped>
  .deposit-main {
    margin-top: 30px;
    margin-bottom: 100px;
    padding-left: 80px;
  }
</style>



// WEBPACK FOOTER //
// desOrder.vue?3429b470